// extracted by mini-css-extract-plugin
export default {"mainPage":"MainPage_mainPage__9SfFZ","active":"MainPage_active__q6D1e"};